module.exports = __webpack_public_path__ + "img/04.d7e6847e.jpg";